import axios from '@/plugins/axios';
import { logApiError } from '@/services/api.js';

const baseUrl = '/api/auth';

export const verifyEmail = async (token) => {
  try {
    const response = await axios.get(`${baseUrl}/verify-email/${token}`);
    return response.data;
  } catch (error) {
    logApiError(error, 'GET', `${baseUrl}/verify-email/:token`);
    throw error;
  }
};

export const resendVerificationEmail = async () => {
  try {
    const response = await axios.post(`${baseUrl}/resend-verification`);
    return response.data;
  } catch (error) {
    logApiError(error, 'POST', `${baseUrl}/resend-verification`);
    throw error;
  }
};
